import { render, staticRenderFns } from "./AvatarComponent.vue?vue&type=template&id=4be64f20&scoped=true"
import script from "./AvatarComponent.vue?vue&type=script&lang=js"
export * from "./AvatarComponent.vue?vue&type=script&lang=js"
import style0 from "./AvatarComponent.vue?vue&type=style&index=0&id=4be64f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be64f20",
  null
  
)

export default component.exports